<template>
	<nk-wrapper v-if="context" spacing="md">
		<nk-form
			:success="success"
			:error="error"
			success-message="Vielen Dank für Ihre Nachricht!"
			success-description="Ihre Meldung ist bei uns eingegangen. Vielen Dank für Ihre Mitwirkung!"
			error-message="Leider ist ein Fehler beim Versand der Nachricht aufgetreten"
			:error-description="`Wir werden versuchen den Fehler schnellstmöglich zu
				beheben. Bitte wenden Sie sich in dringenden Fällen direkt
				<a href='mailto:${genericMail}'>per E-Mail</a>
				an uns.`"
			name="coronaformular"
			:schema="schema"
			@submit="submitForm"
		/>

		<nk-wrapper spacing="md">
			<nk-text v-if="success">
				<nk-button @click.prevent="resetForm">Zurück zum Formular</nk-button>
			</nk-text>
		</nk-wrapper>
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';
import {jumpTo} from '#imports';

export default {
	name: 'NkTemplateFormularKontakt',

	mixins: [TemplatesDefault],

	data() {
		const config = useRuntimeConfig();
		return {
			form: null,
			error: false,
			success: false,
			genericMail:
				config.public.NUXT_PUBLIC_FORM_RECEIVER_KONTAKT_GEMEINDE ||
				'info@webcontact.de',
		};
	},

	computed: {
		schema() {
			return [
				{
					component: 'h2',
					class: 'text-xl my-4',
					children: 'Ihre Kontaktdaten',
					id: 'headline-1',
				},
				{
					component: 'div',
					class: 'flex flex-wrap -m-2',
					id: 'wrapper-1',
					children: [
						{
							component: 'div',
							class: 'w-full p-2',
							id: 'col-1-1',
							children: [
								{
									type: 'select',
									label: 'Anrede',
									name: 'anrede',
									placeholder: 'Bitte wählen Sie...',
									options: [
										{
											label: 'Herr',
											id: 'anrede-herr',
											value: 'Herr',
										},
										{
											label: 'Frau',
											id: 'anrede-frau',
											value: 'Frau',
										},
										{
											label: 'Divers',
											id: 'anrede-divers',
											value: 'Divers',
										},
									],
									validation: 'required',
								},
							],
						},
						{
							component: 'div',
							class: 'w-full sm:w-6/12 p-2',
							id: 'col-1-2',
							children: [
								{
									type: 'text',
									label: 'Vorname',
									placeholder: 'Max',
									name: 'vorname',
									validation: 'required',
								},
							],
						},
						{
							component: 'div',
							class: 'w-full sm:w-6/12 p-2',
							id: 'col-1-3',
							children: [
								{
									type: 'text',
									label: 'Nachname',
									placeholder: 'Mustermann',
									name: 'nachname',
									validation: 'required',
								},
							],
						},
						{
							component: 'div',
							class: 'w-full sm:w-6/12 p-2',
							id: 'col-1-4',
							children: [
								{
									type: 'date',
									label: 'Geburtsdatum',
									name: 'geburtsdatum',
									validation: 'required',
								},
							],
						},
						{
							component: 'div',
							class: 'w-full sm:w-6/12 p-2',
							id: 'col-1-5',
							children: [
								{
									type: 'text',
									label: 'Straße und Hausnummer',
									placeholder: 'Musterstraße 11',
									name: 'strasse',
									validation: 'required',
								},
							],
						},
						{
							component: 'div',
							class: 'w-full sm:flex-1 p-2',
							id: 'col-1-7',
							children: [
								{
									type: 'radio',
									label: 'Wohnort',
									name: 'plz_ort',
									options: this.context.plzOrt,
									value: this.context.plzOrtSelected,
									validation: 'required',
								},
							],
						},
						{
							component: 'div',
							class: 'w-full p-2',
							id: 'col-1-8',
							children: [
								{
									type: 'email',
									label: 'E-Mail Adresse',
									placeholder: 'max.mustermann@beispiel.de',
									name: 'email',
									validation: 'required|email',
								},
							],
						},
						{
							component: 'div',
							class: 'w-full p-2',
							id: 'col-1-9',
							children: [
								{
									type: 'tel',
									label: 'Telefonnummer (optional)',
									help: 'Geben Sie Ihre Telefonnummer für Rückfragen an',
									placeholder: '+49 0123 4567',
									name: 'telefon',
								},
							],
						},
					],
				},
				{
					component: 'h2',
					class: 'text-xl my-4',
					children: 'Reisedaten',
					id: 'headline-2',
				},
				{
					component: 'div',
					class: 'flex flex-wrap -m-2',
					id: 'wrapper-2',
					children: [
						{
							component: 'div',
							class: 'w-full p-2',
							id: 'col-2-1',
							children: [
								{
									type: 'wysiwyg',
									rows: 5,
									label: 'Mitreisende Personen (identische Wohnanschrift)',
									help: `Nachfolgend können Sie uns Mitreisende mit identischer Wohnanschrift
									nennen; bitte jeweils
									<strong>Vor- und Nachname als auch das Geburtsdatum</strong>
									angeben.`,
									name: 'mitreisende',
									validation: 'required',
									'validation-message': {
										required: 'Bitte geben Sie die mitgereisten Personen an!',
									},
								},
							],
						},
						{
							component: 'div',
							class: 'w-full sm:w-6/12 p-2',
							id: 'col-2-2',
							children: [
								{
									type: 'date',
									label: 'Reisedatum',
									name: 'reisedatum',
									validation: 'required',
								},
							],
						},
						{
							component: 'div',
							class: 'w-full sm:w-6/12 p-2',
							id: 'col-2-3',
							children: [
								{
									type: 'text',
									label: 'Reiseland',
									name: 'reiseland',
								},
							],
						},
						{
							component: 'div',
							class: 'w-full p-2',
							id: 'col-2-4',
							children: [
								{
									type: 'radio',
									label: 'Krankheitssymptome vorhanden',
									name: 'krankheitssymptome',
									options: [
										{
											label: 'Ja',
											id: 'krankheitssymptome-ja',
											value: 'Ja',
										},
										{
											label: 'Nein',
											id: 'krankheitssymptome-nein',
											value: 'Nein',
										},
									],
									validation: 'required',
								},
							],
						},
						{
							component: 'div',
							class: 'w-full p-2',
							id: 'col-2-5',
							children: [
								{
									type: 'wysiwyg',
									rows: 5,
									label: 'Wenn ja, welche?',
									name: 'krankheitssymptomeBeschreibung',
									validation: 'symptome',
									'validation-rules': {
										symptome: ({value}) => {
											const form =
												this.$store.state.nuxtKommunen.forms.coronaformular;

											const krankheitssymptome =
												Object.prototype.hasOwnProperty.call(
													form,
													'krankheitssymptome',
												);

											if (
												!krankheitssymptome ||
												(krankheitssymptome &&
													form.krankheitssymptome === 'Nein')
											) {
												return true;
											}

											return form.krankheitssymptome === 'Ja' && value !== '';
										},
									},
									'validation-messages': {
										symptome: 'Bitte geben Sie Ihre Krankheitssymptome an!',
									},
								},
							],
						},
						{
							component: 'div',
							class: 'w-full p-2',
							id: 'col-2-6',
							children: [
								{
									type: 'radio',
									label: 'Ärztliches Zeugnis vorhanden',
									name: 'dateiVorhanden',
									options: [
										{
											label: 'Ja',
											id: 'dateiVorhanden-ja',
											value: 'Ja',
										},
										{
											label: 'Nein',
											id: 'dateiVorhanden-nein',
											value: 'Nein',
										},
									],
									validation: 'required',
									'validation-messages': {
										required:
											'Ärztliches Zeugnis vorhanden ist eine Pflichtangabe.',
									},
								},
							],
						},
						{
							component: 'div',
							class: 'w-full p-2',
							id: 'col-2-7',
							children: [
								{
									type: 'customfile',
									label: 'Datei auswählen',
									name: 'datei',
									accept: 'image/jpeg, image/png, application/pdf',
									validation: 'zeugnis',
									'data-formname': 'coronaformular',
									'validation-rules': {
										zeugnis: () => {
											const form =
												this.$store.state.nuxtKommunen.forms.coronaformular;

											const dateiVorhanden =
												Object.prototype.hasOwnProperty.call(
													form,
													'dateiVorhanden',
												);

											if (
												!dateiVorhanden ||
												(dateiVorhanden && form.dateiVorhanden === 'Nein')
											) {
												return true;
											}

											return (
												form.dateiVorhanden === 'Ja' &&
												this.$el.querySelector('[name="datei"]').value !== ''
											);
										},
									},
									'validation-messages': {
										zeugnis: 'Bitte fügen Sie das ärtzliche Zeugnis hinzu.',
									},
								},
							],
						},
					],
				},
				{
					component: 'div',
					children: [
						{
							type: 'text',
							label: '',
							class: 'opacity-0 absolute top-0 left-0 h-0 w-0 z-0',
							placeholder: 'Bitte leer lassen, dieses Feld ist nur für Roboter',
							tabIndex: '-1',
							autocomplete: 'off',
							name: 'firma',
						},
					],
				},
				{
					component: 'h2',
					class: 'text-xl my-4',
					children: 'Datenschutzerklärung',
					id: 'headline-3',
				},
				{
					component: 'div',
					class: 'flex flex-wrap -m-2',
					id: 'wrapper-3',
					children: [
						{
							component: 'div',
							class: 'w-full p-2',
							id: 'col-9',
							children: [
								{
									type: 'consent',
									consent: `Ja, ich habe die <a href="${this.privacyLink()}" target="_blank" rel="noopener">Datenschutz­erklärung</a> zur Kenntnis genommen und bin damit einverstanden, dass die von mir angegebenen Daten elektronisch erhoben und gespeichert werden. Meine Daten werden dabei nur streng zweckgebunden zur Bearbeitung und Beantwortung meiner Anfrage genutzt. Ich kann meine Einwilligung jederzeit per E-Mail an <a href="mailto:${this.privacyEmail()}">${this.privacyEmail()}</a> widerrufen.`,
									name: 'datenschutz',
									class: 'text-sm',
									validation: 'required',
								},
							],
						},
					],
				},
				{
					component: 'hr',
					class: '',
				},
				{
					component: 'div',
					class: 'flex flex-wrap -m-2',
					id: 'wrapper-4',
					children: [
						{
							component: 'div',
							class: 'w-auto  p-2',
							id: 'col-10',
							children: [
								{
									type: 'submit',
									name: 'Meldung abschicken',
								},
							],
						},
					],
				},
			];
		},
	},

	methods: {
		resetForm() {
			this.form = null;
			this.error = false;
			this.success = false;

			window.setTimeout(() => {
				const firstInput = this.$el.querySelector('input, select, button');

				jumpTo(firstInput);

				firstInput.focus();
			}, 250);
		},

		async submitForm(form) {
			this.form = form;

			if (this.form.firma && this.form.firma.length) {
				this.error = true;
				return false;
			}

			try {
				const formData = new FormData();
				formData.append('anrede', this.form.anrede);
				formData.append('vorname', this.form.vorname);
				formData.append('nachname', this.form.nachname);
				formData.append('geburtsdatum', this.form.geburtsdatum);
				formData.append('email', this.form.email);
				formData.append('telefon', this.form.telefon);
				formData.append('strasse', this.form.strasse);
				formData.append('plz_ort', this.form.plz_ort);
				formData.append('mitreisende', this.form.mitreisende);
				formData.append('reisedatum', this.form.reisedatum);
				formData.append('reiseland', this.form.reiseland);
				formData.append('krankheitssymptome', this.form.krankheitssymptome);
				formData.append(
					'krankheitssymptomeBeschreibung',
					this.form.krankheitssymptomeBeschreibung,
				);
				formData.append('dateiVorhanden', this.form.dateiVorhanden);
				if (this.$el.querySelector('[name="datei"]').files.length) {
					formData.append(
						'datei',
						this.$el.querySelector('[name="datei"]').files[0],
					);
				}

				formData.append('route', this.$route.path);

				const mailResult = await this.$axios.$post('/api/corona', formData, {
					headers: {'Content-Type': 'multipart/form-data'},
				});

				if (!mailResult) {
					this.error = true;
					return false;
				}

				this.success = true;
				return true;
			} catch (err) {
				if (this.$sentry) {
					this.$sentry.captureException(err);
				}
				this.error = true;
				return false;
			}
		},

		privacyLink() {
			return this.options.privacyLink || '/datenschutz';
		},

		privacyEmail() {
			const config = useRuntimeConfig();
			return (
				this.options.privacyEmail ||
				config.public.NUXT_PUBLIC_FORM_RECEIVER_KONTAKT_GEMEINDE
			);
		},
	},
};
</script>
